export default "__VITE_ASSET__BycReska__"